import baseTheme from "@/themes/baseTheme";
import { Input, Select, Typography } from "antd";
import styled from "styled-components";

export const Tile = styled.div`
  height: 200px;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  display: flex;
  flex-direction: column;
  transition: all 0.3s linear;
  cursor: pointer;
  padding: 1rem;
  position: relative;

  &:hover {
    border: 1px solid ${baseTheme.token.colorPrimary};
    color: ${baseTheme.token.colorPrimary};
  }
`;

export const TileTitle = styled.div`
  padding: 0.5rem 0;
  font-size: 1.2em;
`;

export const Backdrop = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export const FormItemContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  width: 100%;
`;

export const FormItemRow = styled.div`
  display: flex;
`;

export const SelectedFieldTypeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 500px;
`;

export const ElementTitle = styled(Typography)`
  margin: 0px;
`;

export const FormSelect = styled(Select)`
  max-width: 500px;
`;
export const FormInput = styled(Input)`
  max-width: 500px;
`;
